/* eslint-disable react/no-unescaped-entities */
import React from 'react';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

const SocialProof = () => {
  return (
    <Box mt={6}>
      <Typography
        variant="h5"
        component="h2"
        align="center"
        gutterBottom
        sx={{ fontWeight: 700 }}
      >
        El poder de la validación
      </Typography>
      <Typography
        variant="body1"
        color="textSecondary"
        align="center"
        sx={{ maxWidth: 900, mx: 'auto', mb: 4 }}
      >
        En el mundo de los negocios, la confianza es el activo más valioso.
        Formar parte de <strong>TNO Business</strong> es posicionar tu marca y
        tu trayectoria en un entorno de máxima credibilidad, respaldado por la
        infraestructura tecnológica y el ecosistema 360° de <strong>TNO Business</strong>.
      </Typography>

      {/* Logos en carrusel simple (grid estático) */}
      <Box mb={2}>
        <Typography
          variant="overline"
          color="textSecondary"
          align="center"
          display="block"
          gutterBottom
        >
          Líderes que ya se han conectado con nuestra red.
        </Typography>
      </Box>

      <Grid container spacing={4} justifyContent="center" alignItems="center">
        <Grid item>
          <Box
            component="img"
            src="/images/logos/isotnobusiness.png"
            alt="TNO Business"
            sx={{ maxWidth: 140, height: 'auto', objectFit: 'contain' }}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default SocialProof;

